/** Prevent an obsolete editor request from saving or updating a later question. */
export async function activeEbookEditorResult<T>(request: Promise<T>, isActive: () => boolean) {
  const result = await request;
  if (!isActive()) throw new Error('题目编辑界面已关闭');
  return result;
}
